























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { Typography, Surface } from '@/components/atoms';
import SuggestionItemWarningApiToken from './SuggestionItemWarningApiToken.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';
import Input from '@/componentsV2/molecules/Inputs/TextField.vue';
import { setFocusOnFirstInput } from '@/utils/setFocusOnFirstInput';
import WarningIcon from '../icons/Warning.vue';
import { IProvider } from '@/models/provider';
import segmentIo from '@/utils/segment.io';
import MerchantService from '@/api/MerchantService';

@Component({
  components: {
    FilledButton,
    Typography,
    Surface,
    SuggestionItemWarningApiToken,
    ValidationObserver,
    ValidationProvider,
    Input,
    WarningIcon
  }
})
export default class WarnApiTokenConnectionProviderTooltip extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop() provider!: IProvider;

  merchantService = new MerchantService();
  loading = false;

  formData = {
    apiToken: '',
    account: this.provider.account
  };

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  get tPrefix() {
    return 'common.components.businessProvider';
  }

  cancel() {
    this.$emit('cancel');
  }

  async confirm() {
    this.$emit('confirm');
  }

  async updateConnection() {
    try {
      this.loading = true;
      const isFormValid = await this.validateForm();

      if (!isFormValid) {
        setFocusOnFirstInput('input[aria-invalid="true"]');
        this.loading = false;
        return;
      }

      const { links } = this.provider;

      await this.merchantService.disconnect(links.oauthRevoke);

      await this.merchantService.connect(links.oauthApiToken, {
        account: this.formData.account,
        apiToken: this.formData.apiToken
      });

      this.$notification(
        `Connection ${this.provider.name} updated with success `,
        'success'
      );

      this.$emit('updatedConnection');
    } catch (err) {
      this.loading = false;
      this.$notification('Error to update connection', 'error');
    }
  }

  async disconnectProvider() {
    this.$emit('disconnect');
  }

  validateForm() {
    const formRef = this.$refs.observer;
    return formRef.validate();
  }

  trackHelpLink() {
    segmentIo.track('Clicked Integration Help Link', {
      Provider: this.provider.name,
      Link: 'Clover Setup Guide',
      Origin: 'Action Needed Tooltip'
    });
  }
}
